import React, { Component } from "react";
import PropTypes from "prop-types";
import { StyledContentDetails } from "../styled/styles";
import { connect } from "react-redux";
import axios from "axios";
import {
  deleteUserAssets,
  publishTemplate,
  resetPage,
} from "../../_actions/sidebarSliderActions";
import { TldrConfirmationModal, TldrProgressDialog } from "./statelessView";
import TldrPublishTemplateModal from "./TldrPublishTemplateModal";
import { withRouter } from "react-router-dom";
import { cloneTemplate } from "../../_actions/storiesActions";
import { analyticsTrackEvent } from "../../_utils/common";
import { FeatureCodes } from "../details/constants";
import connectedFeatureAvailabilityWrapper from "./withFeatureAvailability";
import {
  FaArrowAltCircleDown,
  FaArrowAltCircleUp,
  FaArrowCircleRight,
  FaEllipsisV,
  FaFileUpload,
  FaTrash,
} from "react-icons/fa";
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  IconButton,
  Icon,
} from "@chakra-ui/react";
import TldrMoveToFolderModal from "../home/TldrMoveToFolderModal";
import { TldrNewFolderDialog } from "../styled/home/statelessView";
import { withTranslation } from "react-i18next";
import {
  createNewFolder,
  moveToFolder,
  removeFolderContent,
} from "../../_actions/folderActions";

class TemplateItemActions extends Component {
  signal = axios.CancelToken.source();

  constructor(props) {
    super(props);
    this.state = {
      showDeletePopup: false,
      showPublishPopup: false,
      inProgress: false,
      showCloneModal: false,
      showMoveToFolderModal: false,
      showNewFolderModal: false,
      showRemoveFromFolderModal: false,
    };
  }

  delete = () => {
    this.props.delete(this.props, this.signal.token).then(() => {
      this.setState({
        showDeletePopup: false,
      });

      if (this.props.onActionComplete) {
        this.props.onActionComplete();
      }
    });
  };

  publish = async (name, tags, categories) => {
    var arrayOfCategories = [];
    categories.forEach((category) => {
      arrayOfCategories.push(category.id);
    });

    const payload = {
      template: "story",
      title: name,
      tags: tags,
      publish: true,
      categories: arrayOfCategories,
    };

    this.props.publishTemplate(this.props.id, payload, this.signal).then(() => {
      this.setState({
        showPublishPopup: false,
        inProgress: false,
      });
    });

    analyticsTrackEvent("publishTemplate");
  };

  toggleDeletePopup = () => {
    this.setState({ showDeletePopup: !this.state.showDeletePopup });
  };

  togglePublishPopup = () => {
    this.setState({ showPublishPopup: !this.state.showPublishPopup });
  };

  componentWillUnmount() {
    this.signal.cancel("The user aborted a request.");
  }

  handleCloneTemplate = () => {
    this.setState({ showCloneModal: true }, () => {
      this.props
        .cloneTemplate(
          this.props?.payload?.content?.meta?.id,
          this.signal,
          this.props,
          true
        )
        .then(() => {
          this.setState({ showCloneModal: false });
        });
    });
  };

  handleMoveToFolder = (id, name) => {
    const { id: templateItemId } = this.props;
    const payload = {
      content_ids: [templateItemId],
    };

    this.props
      .moveToFolder(payload, id, name, this.signal.token)
      .then((res) => {
        this.setState(
          {
            showMoveToFolderModal: false,
            inProgress: false,
          },
          () => {
            this.props.resetPage("");
            if (this.props.onActionComplete) {
              this.props.onActionComplete();
            }
          }
        );
      })
      .catch((error) => {
        this.setState({
          showMoveToFolderModal: false,
          inProgress: false,
        });
      });
  };

  handleCreateNewFolder = (name) => {
    this.props
      .createNewFolder(name, this.signal.token, this.props)
      .then((folder) => {
        this.setState(
          {
            showNewFolderModal: false,
            inProgress: false,
          },
          () => {
            this.handleMoveToFolder(folder.id, folder.name);
          }
        );
      })
      .catch(() => {
        this.setState({
          showNewFolderModal: false,
          inProgress: false,
        });
      });
  };

  handleRemoveFromFolder = () => {
    const { id: templateItemId, currentFolderId } = this.props;
    const payload = {
      remove_content_ids: [templateItemId],
    };

    this.props.resetPage("");

    this.props
      .removeFolderContent(currentFolderId, payload, this.signal.token)
      .then((res) => {
        this.setState(
          {
            showRemoveFromFolderModal: false,
            inProgress: false,
          },
          () => {
            if (this.props.onActionComplete) {
              this.props.onActionComplete();
            }
          }
        );
      })
      .catch(() => {
        this.setState({
          showRemoveFromFolderModal: false,
          inProgress: false,
        });
      });
  };

  render() {
    const {
      showDeletePopup,
      showPublishPopup,
      inProgress,
      showCloneModal,
      showMoveToFolderModal,
      showNewFolderModal,
      showRemoveFromFolderModal,
    } = this.state;
    const {
      modalFor,
      title,
      showExtraOptions,
      currentFolderId,
      showRemoveFromFolder,
      t,
    } = this.props;

    return (
      <StyledContentDetails>
        <div onClick={(e) => e.stopPropagation()}>
          <Menu isLazy>
            <MenuButton
              as={IconButton}
              icon={<Icon as={FaEllipsisV} />}
              minW="0"
              h="0"
              display="flex"
              sx={{
                ":focus": {
                  boxShadow: "none",
                },
              }}
            />
            <MenuList>
              <MenuItem
                icon={<FaArrowCircleRight />}
                onClick={(e) => {
                  e.stopPropagation();
                  this.handleCloneTemplate();
                }}
              >
                {t("clone", { ns: "common" })}
              </MenuItem>
              <MenuItem
                icon={<FaFileUpload />}
                onClick={(e) => {
                  e.stopPropagation();
                  this.props.checkFeatureAvailability(
                    FeatureCodes.PUBLISH_TEMPLATE,
                    () => this.togglePublishPopup()
                  );
                }}
              >
                {t("publish", { ns: "common" })}
              </MenuItem>
              {showExtraOptions && (
                <MenuItem
                  icon={<FaArrowAltCircleUp />}
                  onClick={(e) => {
                    e.stopPropagation();
                    this.setState({
                      showMoveToFolderModal: true,
                    });
                  }}
                >
                  {t("move_to_folder.action")}
                </MenuItem>
              )}
              {showExtraOptions && showRemoveFromFolder && (
                <MenuItem
                  icon={<FaArrowAltCircleDown />}
                  onClick={(e) => {
                    e.stopPropagation();
                    this.setState({
                      showRemoveFromFolderModal: true,
                    });
                  }}
                >
                  {t("move_back.action")}
                </MenuItem>
              )}
              <MenuItem
                icon={<FaTrash />}
                onClick={(e) => {
                  e.stopPropagation();
                  this.toggleDeletePopup();
                }}
              >
                {t("delete", { ns: "common" })}
              </MenuItem>
            </MenuList>
          </Menu>
        </div>

        {showDeletePopup && (
          <div onClick={(e) => e.stopPropagation()}>
            <TldrConfirmationModal
              modalFor={modalFor}
              inProgress={inProgress}
              show={showDeletePopup}
              onHide={(e) => {
                this.setState({
                  ...this.state,
                  showDeletePopup: false,
                });
              }}
              onYes={() => {
                this.setState(
                  {
                    inProgress: true,
                  },
                  this.delete
                );
              }}
            />
          </div>
        )}

        {showPublishPopup && (
          <div onClick={(e) => e.stopPropagation()}>
            <TldrPublishTemplateModal
              show={showPublishPopup}
              inProgress={inProgress}
              templateName={title}
              onHide={(e) => {
                this.setState({
                  ...this.state,
                  showPublishPopup: false,
                });
              }}
              onYes={(name, tags, category) => {
                this.setState(
                  {
                    inProgress: true,
                  },
                  () => this.publish(name, tags, category)
                );
              }}
            />
          </div>
        )}

        {showCloneModal ? (
          <TldrProgressDialog
            inProgress={inProgress}
            show={showCloneModal}
            onHide={() => {
              this.setState({
                ...this.state,
                showCloneModal: false,
              });
            }}
            onYes={() => {
              this.setState({
                inProgress: true,
              });
            }}
          ></TldrProgressDialog>
        ) : null}

        {showMoveToFolderModal ? (
          <div onClick={(e) => e.stopPropagation()}>
            <TldrMoveToFolderModal
              inProgress={inProgress}
              show={showMoveToFolderModal}
              onHide={() => {
                this.setState({
                  showMoveToFolderModal: false,
                });
              }}
              onYes={(folderId, folderName) => {
                this.setState(
                  {
                    inProgress: true,
                  },
                  () => this.handleMoveToFolder(folderId, folderName)
                );
              }}
              onAddFolder={() => {
                this.setState({
                  showNewFolderModal: true,
                  showMoveToFolderModal: false,
                });
              }}
              currentFolderId={currentFolderId}
            />
          </div>
        ) : null}

        {showNewFolderModal ? (
          <TldrNewFolderDialog
            inProgress={inProgress}
            show={showNewFolderModal}
            onHide={() => {
              this.setState({
                showNewFolderModal: false,
              });
            }}
            onYes={(name) => {
              this.setState(
                {
                  inProgress: true,
                },
                () => this.handleCreateNewFolder(name)
              );
            }}
          />
        ) : null}

        {showRemoveFromFolderModal ? (
          <TldrConfirmationModal
            inProgress={inProgress}
            show={showRemoveFromFolderModal}
            customMessage={t("move_back.heading", { name: modalFor })}
            customBodyMessage={t("move_back.message")}
            customPrimaryActionText={t("move_back_button.text")}
            onHide={() => {
              this.setState({ showRemoveFromFolderModal: false });
            }}
            onYes={() => {
              this.setState(
                {
                  inProgress: true,
                },
                () => this.handleRemoveFromFolder()
              );
            }}
          />
        ) : null}
      </StyledContentDetails>
    );
  }
}

TemplateItemActions.propTypes = {
  delete: PropTypes.func.isRequired,
  publishTemplate: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  closeModal: state.sidebarSlider.closeTemplateModal,
  auth: state.auth,
  subscription: state.subscription,
});

const mapDispatchToProps = (dispatch) => ({
  delete: (props, token) => dispatch(deleteUserAssets(props, token)),
  publishTemplate: (id, payload, signalToken) =>
    dispatch(publishTemplate(id, payload, signalToken)),
  cloneTemplate: (storyId, signal, props, openNewTab) =>
    dispatch(cloneTemplate(storyId, signal, props, openNewTab)),
  moveToFolder: (payload, folderId, folderName, token) =>
    dispatch(moveToFolder(payload, folderId, folderName, token)),
  createNewFolder: (name, token, props) =>
    dispatch(createNewFolder(name, token, props)),
  removeFolderContent: (folderId, payload, signalToken) =>
    dispatch(removeFolderContent(folderId, payload, signalToken)),
  resetPage: () => dispatch(resetPage()),
});

export default connectedFeatureAvailabilityWrapper(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withRouter(withTranslation(["folders", "common", "billing"])(TemplateItemActions)))
);
